export function useInit() {
  onMounted(() => {
    document.querySelector("body").focus();
  });
}

export function useUpdate(value, callback) {
  let timeoutId = null;
  let stop = null;
  stop = watch(
    value,
    (data) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        if (data) {
          stop();
          callback(data);
        }
      }, 0);
    },
    { immediate: true },
  );
}

export function useResetAnimationTimeline() {
  document.querySelector("html").classList.add("reset-animation");
  requestAnimationFrame(() => {
    document.querySelector("html").classList.remove("reset-animation");
  });
}
